// communicating with accounts app via postMessage

const getFromAccountsExecutor = (actionName, body) => {
  return new Promise((resolve) => {
    // set up iframe and init
    const host = process.env.API_HOST;
    const iframe = document.createElement('iframe');
    const auth = `${host}/auth/`;
    iframe.setAttribute('src', auth);
    iframe.style.display = 'none';
    iframe.id = 'accounts-iframe';
    document.body.appendChild(iframe);

    iframe.onload = () => {
      iframe.contentWindow.postMessage({ action: actionName, ...body }, host);
    };

    // listen to event
    const listener = (event) => {
      // check origin
      const origin = event.origin || event.originalEvent.origin;
      if (origin !== host) { return; }
      // check action
      if (event.data.action !== actionName) { return; }
      // all are good
      resolve({ ...event.data });
    };

    window.addEventListener('message', listener);
  });
};

export default getFromAccountsExecutor;



// WEBPACK FOOTER //
// ../src/utils/getFromAccountsExecutor.js